// redux/slices/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const loading = createSlice({
    name: 'loading',
    initialState: {
      visible: false,
      message: 'Loading',
    },
    reducers: {
      setLoading: (state, action) => {
        // Correctly update properties of the state
        state.visible = action.payload.visible;
        state.message = action.payload.message;
      },
    },
  });

export const { setLoading } = loading.actions;

export default loading.reducer;
